<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import axios from "axios";
import TabPesertaDetail from "./components/tab-peserta-detail.vue";

export default {
  page: {
    title: "Work Order Detail",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
		TabPesertaDetail
  },

  data() {
    let sortOrders = [];

    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Kode", name: "kode" },
      { width: "auto", label: "Keterangan", name: "keterangan" },
      { width: "180px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    const menu = "Work Order Detail";
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),

			headerParam: {
				id_work_order: null
			},

			workOrder: {
				loading: true,
				data: [],
			},
    };
  },

  mounted() {
		this.headerParam.id_work_order = this.$route.params.id;
		
		if(this.headerParam.id_work_order){
			this.getData(this.headerParam.id_work_order);

		}
  },

  methods: {
		async getData(id){
			Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

			try{
				const response = await axios({
					url: process.env.VUE_APP_BACKEND_URL_VERSION + "work-order/" + id,
					method: "get",
					headers: {
						Accept: "application/json",
						Authorization: "Bearer " + localStorage.access_token,
					},
				});

				if(response?.data?.meta?.code == 200) {
					const data = response.data.data;
					this.workOrder.data = data;
				}
			} catch (error) {
        console.log(error);
        Swal.fire({ icon: "error", title: "Peringatan", text: "Terjadi kesalahan pada sistem" });
      } finally {
				Swal.close();
      }
		},

		backButton(){
			this.$router.push({
        name: "work-order",
      });
		},
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <!-- Content -->
        <div class="card">
          <div class="card-body">
            <!-- Filter -->
            <div class="row">
              <!-- bagian navigasi halaman -->
							<div class="col-md-12 d-flex justify-content-between align-item-center">
								<b-button
									size="sm"
									variant="danger"
									class="fw-bold"
									@click="backButton"
								>
									<i class="fa fa-arrow-left me-1"></i>
									Kembali
								</b-button>
							</div>
							<!-- --------------------- -->
            </div>

            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table border="0" class="mb-2">
									<tr class="mb-2">
										<td><b>Kode</b></td>
										<td>&nbsp;:&nbsp;</td>
										<td>{{ workOrder.data.kode }}</td>
									</tr>
									<tr class="mb-2">
										<td><b>Keterangan</b></td>
										<td>&nbsp;:&nbsp;</td>
										<td>{{ workOrder.data.keterangan }}</td>
									</tr>
								</table>
              </div>
              
            </div>

          </div>
        </div>
      </div>

			<div class="col-12">
				<b-tabs nav-class="nav-tabs-custom">
					<b-tab title="Peserta" active>
						<TabPesertaDetail 
							v-if="headerParam.id_work_order"
							:idWorkOrder = headerParam.id_work_order
						/>
					</b-tab>
				</b-tabs>
			</div>

    </div>
  </Layout>
</template>